﻿

class CarouselCardsDirectiveController {

    cards: any[] = [];
    activeCardIndex: number;

    private _options: any;
    
    set options(value) {
        this._options = value;
        this.adjustPosition();
    }

    addCard(card: any) {
        this.cards.push(card);
        if (card.isActive) {
            this.activeCardIndex = this.cards.indexOf(card);
        }
        this.adjustSpots();
        this.adjustPosition();
    }

    activate(card: any) {
        if (typeof card === "string") {
            card = this.cards.filter(c => c.name === card)[0];
        }

        this.cards.forEach((value, index) => {
            value.elem.removeClass(`from-before`);
            value.elem.removeClass(`from-after`);
            value.isActive = value == card;
            if (value.isActive && index < this.activeCardIndex) {
                value.elem.addClass(`from-before`);    
            }
            else if (value.isActive && index > this.activeCardIndex) {
                value.elem.addClass(`from-after`);    
            }
        });
        this.activeCardIndex = this.cards.indexOf(card);
        this.adjustSpots();
        this.adjustPosition();
    }

    private adjustSpots() {
        let activeIndex;
        this.cards.forEach((value, index) => {
            if (value.isActive) {
                activeIndex = index;
            }
            value.elem.removeClass("active");
            for (var i = 0; i < this.cards.length; ++i) {
                value.elem.removeClass(`active-before-${i}`);
                value.elem.removeClass(`active-after-${i}`);
            }
        });
        this.cards.forEach((value, index) => {
            if (value.isActive) {
                value.elem.addClass("active");
            } else if (index < activeIndex) {
                value.elem.addClass(`active-before-${activeIndex - index}`);
            } else if (index > activeIndex) {
                value.elem.addClass(`active-after-${index - activeIndex}`);
            }
        });
    }

    leftPaddingElem: any;
    rightPaddingElem: any;

    private adjustPosition() {
        if (!this._options) return;
        if (!!this.leftPaddingElem) {
            this.leftPaddingElem.remove();
            this.leftPaddingElem = null;
        }
        if (!!this.rightPaddingElem) {
            this.rightPaddingElem.remove();
            this.rightPaddingElem = null;
        }

        this.leftPaddingElem = document.createElement(this._options.paddingElement);
        this.rightPaddingElem = document.createElement(this._options.paddingElement);
        if (!!this.cards.length) {
            let parent = angular.element(this.cards[0].elem).parent();
            parent.append(this.rightPaddingElem);
            parent.prepend(this.leftPaddingElem, this.cards[0].elem);
        }

        let activeIndex = this.activeCardIndex;
        let elemsToTheLeft = activeIndex, elemsToTheRight = this.cards.length - 1 - activeIndex,
            diff = Math.abs(elemsToTheLeft - elemsToTheRight);
        if (elemsToTheRight > elemsToTheLeft) {
            angular.element(this.leftPaddingElem).addClass(`active-before-${Math.abs(elemsToTheLeft + 1)} offset-${diff}`);
            angular.element(this.rightPaddingElem).addClass(`offset-0`);
        }
        if (elemsToTheRight < elemsToTheLeft) {
            angular.element(this.leftPaddingElem).addClass(`offset-0`);
            angular.element(this.rightPaddingElem).addClass(`active-after-${Math.abs(elemsToTheRight + 1)} offset-${diff}`);
        }

    }

    moveLeft() {
        if (this.activeCardIndex > 0) {
            this.activate(this.cards[this.activeCardIndex - 1]);
        }
    }

    moveRight() {
        if (this.activeCardIndex < this.cards.length - 1) {
            this.activate(this.cards[this.activeCardIndex + 1]);
        }
    }

}


class CarouselCardDirectiveController {
    index: number;
}

angular.module('fliptoWeb')
    .directive('ftCarouselCards', [function () {

        return {
            controller: CarouselCardsDirectiveController,
            require: "ftCarouselCards",
            controllerAs: "$ftCarouselCards",
            bindToController: true,
            link: function (scope, elem, attrs, ctrl) {
                ctrl.options = scope.$eval(attrs.options);
            }
        };
    }])
    .directive('ftCarouselCard', [function () {

        return {
            controller: CarouselCardDirectiveController,
            require: ["^ftCarouselCards", "ftCarouselCard"],
            link: function (scope, elem, attrs, ctrls) {
                const cardsCtrl = ctrls[0];
                const cardCtrl = ctrls[1];
                const card = { elem: elem, isActive: attrs.hasOwnProperty("active"), name: attrs.ftCarouselCard };
                cardsCtrl.addCard(card);
                cardCtrl.index = cardsCtrl.cards.indexOf(card);
            }
        };
    }])
    .directive('ftCarouselCardTrigger', [function () {

        return {
            scope: false,
            require: "^ftCarouselCards",
            link: function CarouselCardTriggerLinkFn(scope, elem, attrs, ctrl) {

                function setActive() {
                    scope.$apply(() => {
                        ctrl.activate(attrs.ftCarouselCardTrigger);
                    });
                }

                elem.bind("click", setActive);

                scope.$on("$destroy", () => {
                    elem.unbind("click", setActive);
                });
            }
        };
    }])
    .directive('ftCarouselCardMoveLeftOrRight', [function () {

        return {
            scope: false,
            require: ["^ftCarouselCards", "ftCarouselCard"],
            link: function (scope, elem, attrs, ctrls) {

                const cardsCtrl = ctrls[0];
                const cardCtrl = ctrls[1];

                function move() {
                    scope.$apply(() => {
                        if (cardCtrl.index > cardsCtrl.activeCardIndex) {
                            cardsCtrl.moveRight();
                        } else {
                            cardsCtrl.moveLeft();
                        }
                    });
                }

                elem.bind("click", move);

                scope.$on("$destroy", () => {
                    elem.unbind("click", move);
                });
            }
        };
    }]);